var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('navbar')],1)],1),_c('b-row',[_c('b-col',[(_vm.isIdle)?_c('ModalIdle'):_vm._e(),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }